export default __webpack_public_path__ + "static/media/stop.dd27d661.svg";